import type { Meta, StoryFn } from '@storybook/react';

import { ErrorState } from '@pega/cosmos-react-core';
import type { ErrorStateProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/ErrorState',
  component: ErrorState,
  parameters: {
    layout: 'centered'
  }
} as Meta;

interface ErrorStateStoryProps extends ErrorStateProps {
  displayRetry?: boolean;
}

export const ErrorStateDemo: StoryFn<ErrorStateStoryProps> = (args: ErrorStateStoryProps) => {
  return <ErrorState message={args.message} onRetry={args.displayRetry ? () => {} : undefined} />;
};

ErrorStateDemo.args = {
  message: 'Unknown error',
  displayRetry: false
};

ErrorStateDemo.argTypes = {
  message: { control: { type: 'text' } },
  displayRetry: { control: { type: 'boolean' } }
};
